import React from "react";
import PageNotFound from "../components/PageNotFound";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return <h1>Something went wrong. Please try again later.</h1>;
      // return <PageNotFound />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
